export const TEEN_ROUTES = {
    DOWNLOAD_APP: `/teens/download-app`
} as const;